export default __webpack_public_path__ + "static/media/IMG_5352.4595acd3.WEBP";